// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__fT6vK","footer":"ModalInfo_footer__1gEoD"};